import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../../utils/propertybanner.css"

const   PropertyDetailsHeader = ({ bannerImage, headertitle}) => {
  

// alert(`${bannerImage}`);


    let HeaderTitle = headertitle;
    let publicUrl = process.env.PUBLIC_URL + "/";
    let Subheader = "Property Details";
    const inlineStyle = {
      backgroundImage: `url(${bannerImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      position: "relative",
      boxShadow: "inset 0 0 100px rgba(0,0,0,0.2)", // subtle dark edges
     // backgroundSize: "auto"
    };
    return (
       <div className="pd-header-wrapper">
      <img src={bannerImage} alt="Property Banner" className="pd-banner-img" />

      <div className="pd-content container">
        <h2 className="pd-title">{HeaderTitle}</h2>
        <ul className="pd-breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>{Subheader}</li>
        </ul>
      </div>
    </div>
    );

}

export default  PropertyDetailsHeader  ;
